import axios from 'axios';

import { FLEX_DUTY_HOUR_TYPES } from 'RestAPIs/endpoints';

export interface FlexDutyHourTypesValues {
  code: string;
  colorCode: string;
  dccCode: string;
  dccflags: string[];
  description: string;
  flags: string[];
  id: number;
}

export const getFlexDutyHourTypes = () => {
  return axios.get<FlexDutyHourTypesValues[]>(`${FLEX_DUTY_HOUR_TYPES}`);
};
